var _path, _g, _g2, _path2, _path3, _path4, _g3, _path5, _path6, _g4, _path7, _path8, _path9, _path10, _path11, _path12, _g5, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _g6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraphicsRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 394,
    height: 99,
    viewBox: "0 0 394 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_48_457)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M0 267.02C56.17 148.41 164.64 -6.96 242.52 -112C255.24 -53.09 268.25 8.63 278.51 69.25C284.27 62.79 290.06 56.36 295.9 49.98C329.14 14.14 399.24 -59.79 436.46 -91.64C411.77 -38.24 345.66 50.81 314.42 100.49C296.16 129.65 267.97 170.32 248.62 199.4L232.99 137.99C224.17 103.17 216.22 68.15 208.95 32.99C188.83 57.28 168.2 81.19 146.98 104.64C110.16 144.9 41.71 231.38 0 267.02Z",
    fill: "#9B49FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_48_457)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M233.346 26.9648L197.318 23.6077L196.798 29.1852L232.826 32.5423L233.346 26.9648Z",
    fill: "#BDE7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.549 10.3128L213.971 9.79312L210.614 45.8215L216.192 46.3412L219.549 10.3128Z",
    fill: "#BDE7FF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_48_457)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M412.991 67.5398L375 41.9953L406.768 35.7723L412.991 67.5398ZM387.468 44.5102L405.957 56.9421L402.929 41.4816L387.468 44.5102Z",
    fill: "#F9DC16"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_48_457)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M128.468 53.2911C125.536 41.5037 130.908 28.2327 141.33 21.9748C152.126 15.4903 167.033 17.3161 176.001 26.2207C177.103 27.312 178.177 28.5582 179.194 29.922C182.334 34.1328 184.668 39.0835 186.929 43.8742C189.175 48.6295 191.288 53.1132 194.094 56.8768C196.695 60.3647 199.593 62.7788 202.949 64.2592C209.669 67.221 218.379 66.0262 226.244 61.0656C247.512 47.654 250.143 18.6146 250.288 6.74755C250.395 -2.18037 249.623 -11.2813 248.873 -20.0804C247.858 -31.9927 246.81 -44.2979 247.913 -56.4214C249.706 -76.034 257.232 -93.5731 269.104 -105.812C282.579 -119.704 301.738 -126.353 319.098 -123.167C330.268 -121.117 341.559 -114.89 351.754 -105.161C356.755 -100.391 361.724 -94.6266 367.392 -87.0249C370.084 -83.4141 372.701 -79.7117 375.234 -76.1276C381.068 -67.878 387.097 -59.3508 390.563 -49.5672C394.458 -38.5794 394.152 -27.4855 389.735 -19.1242C387.328 -14.5749 382.42 -7.69199 367.641 -0.475559C357.817 4.3219 349.497 6.84426 341.463 7.46565C331.362 8.24281 321.97 5.76546 315.014 0.480664C312.51 -1.42104 310.254 -3.71061 308.301 -6.33023C304.383 -11.5844 299.989 -19.7011 297.126 -40.0638C296.805 -42.3464 296.562 -44.8263 296.326 -47.2254C295.62 -54.5027 290.654 -72.2013 287.667 -77.1522L289.495 -78.5039C292.845 -73.1048 297.843 -55.0532 298.583 -47.4528C298.826 -44.9663 299.054 -42.6146 299.368 -40.3729C302.161 -20.5378 306.381 -12.7088 310.14 -7.66705C311.966 -5.21884 314.065 -3.08503 316.378 -1.33088C322.89 3.613 331.73 5.93278 341.279 5.19673C349.02 4.60186 357.079 2.147 366.639 -2.51707C380.822 -9.44007 385.469 -15.9203 387.727 -20.1899C391.852 -27.9909 392.106 -38.4259 388.426 -48.8148C385.063 -58.2981 379.129 -66.6985 373.388 -74.8149C370.869 -78.3804 368.265 -82.0577 365.592 -85.6424C359.988 -93.1584 355.094 -98.8385 350.192 -103.515C340.317 -112.938 329.43 -118.956 318.696 -120.925C302.069 -123.973 283.691 -117.57 270.734 -104.215C259.217 -92.345 251.916 -75.2932 250.17 -56.191C249.083 -44.2707 250.122 -32.0631 251.129 -20.2613C251.887 -11.3981 252.665 -2.2433 252.555 6.79694C252.241 32.6533 243.094 53.1401 227.457 63.0022C218.954 68.3628 209.454 69.6134 202.042 66.3504C198.324 64.7105 195.131 62.0639 192.297 58.263C189.33 54.2833 187.069 49.4926 184.885 44.8591C182.675 40.1754 180.392 35.3317 177.363 31.27C176.415 29.9993 175.424 28.8482 174.415 27.8437C166.297 19.7841 152.283 18.0636 142.509 23.9364C137.743 26.8009 133.94 31.4394 131.803 37.0102C129.836 42.1417 129.436 47.6407 130.651 52.655L128.479 53.306L128.468 53.2911Z",
    fill: "#E7DD21"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M128.792 87.0446L121.322 89.205C120.69 89.3869 119.977 89.2982 119.282 88.8939L126.752 86.7335C127.443 87.1405 128.159 87.2264 128.792 87.0446Z",
    fill: "#A56E00"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_48_457",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 119,
    y: 86,
    width: 10,
    height: 4
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M128.792 87.0446L121.322 89.205C120.69 89.3869 119.977 89.2982 119.282 88.8939L126.752 86.7335C127.443 87.1405 128.159 87.2264 128.792 87.0446Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_48_457)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.792 87.0446L121.322 89.205C120.69 89.3869 119.977 89.2982 119.282 88.8939L126.752 86.7335C127.443 87.1405 128.159 87.2264 128.792 87.0446Z",
    fill: "#A56E00"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M57.102 10.7485L64.5716 8.58803C63.7312 8.83206 63.034 9.55486 62.7408 10.649L55.2711 12.8095C55.5643 11.7153 56.2615 10.9925 57.102 10.7485Z",
    fill: "#A56E00"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_48_457",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 55,
    y: 8,
    width: 10,
    height: 5
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M57.102 10.7485L64.5716 8.58803C63.7312 8.83206 63.034 9.55486 62.7408 10.649L55.2711 12.8095C55.5643 11.7153 56.2615 10.9925 57.102 10.7485Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_48_457)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.737 10.6518L55.2673 12.8123C55.5605 11.7181 56.2577 10.9953 57.0982 10.7513L64.5679 8.59082C63.7274 8.83485 63.0302 9.55765 62.737 10.6518Z",
    fill: "#A56E00"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M126.752 86.7335L119.282 88.8939L49.2335 47.723L56.7022 45.5691L126.752 86.7335Z",
    fill: "#A56E00"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7088 40.3702L47.2391 42.5307L55.2711 12.8095L62.7371 10.6518L54.7088 40.3702Z",
    fill: "#A56E00"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M136.661 50.07C138.277 51.0216 139.172 53.3523 138.654 55.2689L130.626 84.9873C130.108 86.9039 128.371 87.6888 126.755 86.7372L56.7051 45.5728C55.0886 44.6212 54.1941 42.2905 54.7116 40.3739L62.7399 10.6555C63.2574 8.7389 64.9943 7.95403 66.6108 8.90562L136.661 50.07Z",
    fill: "#E7DD21"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2674 44.2199C56.2943 43.5191 55.7691 41.9626 56.0958 40.7507L64.124 11.0323C64.2609 10.5186 64.5404 10.142 64.8855 10.0006C65.2548 9.85284 65.6321 9.99477 65.8796 10.1407L135.929 51.3051C135.984 51.3397 136.039 51.3743 136.09 51.4117C137.063 52.1125 137.588 53.669 137.261 54.8809L129.233 84.5993C129.096 85.113 128.817 85.4896 128.472 85.631C128.102 85.7787 127.725 85.6368 127.478 85.4909L57.4278 44.3265C57.3731 44.2919 57.3184 44.2573 57.2674 44.2199Z",
    fill: "#D6B700"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7022 45.5691L49.2325 47.7295C47.6161 46.7779 46.7215 44.4473 47.2391 42.5306L54.7088 40.3702C54.1912 42.2868 55.0857 44.6175 56.7022 45.5691Z",
    fill: "#A56E00"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_48_457",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 47,
    y: 40,
    width: 10,
    height: 8
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7022 45.5691L49.2325 47.7295C47.6161 46.7779 46.7215 44.4473 47.2391 42.5306L54.7088 40.3702C54.1912 42.2868 55.0857 44.6175 56.7022 45.5691Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_48_457)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.7021 45.5691L49.2325 47.7295C49.0156 47.6013 48.8117 47.4519 48.6245 47.2783L56.0942 45.1178C56.2814 45.2914 56.4853 45.4409 56.7021 45.5691Z",
    fill: "#A56E00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.0943 45.1179L48.6246 47.2783C48.3846 47.0572 48.166 46.8028 47.9743 46.5224L55.444 44.362C55.6357 44.6423 55.8543 44.8967 56.0943 45.1179Z",
    fill: "#A56E00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.444 44.3619L47.9743 46.5224C47.2019 45.3937 46.8788 43.8603 47.2391 42.5306L54.7088 40.3702C54.3485 41.6998 54.6716 43.2332 55.444 44.3619Z",
    fill: "#A56E00"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M137.264 54.8847C137.591 53.6727 137.066 52.1162 136.093 51.4154C136.042 51.378 135.987 51.3435 135.932 51.3089L129.642 47.6147C127.173 50.6095 123.983 53.0468 120.489 54.7529C114.27 57.7844 107.172 58.67 100.249 58.3477C93.3276 58.0291 86.5125 56.5588 79.7327 55.097C77.6335 54.6446 75.5408 54.193 73.4415 53.7406L127.471 85.4899C127.721 85.6396 128.099 85.7815 128.465 85.63C128.81 85.4886 129.086 85.1148 129.227 84.5984L137.255 54.88L137.264 54.8847Z",
    fill: "#AA5D2F"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6022 22.6038L71.9331 24.9756C71.5804 26.2301 70.1358 26.8028 69.0124 26.1329L67.2329 25.071C66.1123 24.4048 64.6677 24.9775 64.3122 26.2283L62.8939 31.2519C62.65 32.1179 63.0182 33.0377 63.7931 33.5036L67.3856 35.6489C68.1577 36.1111 68.5287 37.0347 68.2849 37.9007L67.0424 42.3003C66.7986 43.1663 67.1668 44.0861 67.9417 44.552L72.0106 46.9799C73.1312 47.6461 74.5758 47.0734 74.9313 45.8226L75.6004 43.4508C75.9532 42.1963 77.3977 41.6236 78.5211 42.2935L80.3007 43.3554C81.4213 44.0216 82.8658 43.4489 83.2213 42.1981L84.6396 37.1745C84.8835 36.3085 84.5153 35.3887 83.7404 34.9228L80.1479 32.7775C79.3758 32.3153 79.0048 31.3917 79.2486 30.5257L80.4911 26.1261C80.7349 25.2601 80.3667 24.3402 79.5918 23.8743L75.5229 21.4465C74.4023 20.7803 72.9577 21.353 72.6022 22.6038Z",
    fill: "#3D3206"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M118.872 50.3227L118.203 52.6944C117.851 53.9489 116.406 54.5216 115.283 53.8518L113.503 52.7899C112.382 52.1237 110.938 52.6964 110.582 53.9472L109.164 58.9707C108.92 59.8367 109.288 60.7566 110.063 61.2225L113.656 63.3678C114.428 63.83 114.799 64.7536 114.555 65.6196L113.313 70.0191C113.069 70.8852 113.437 71.805 114.212 72.2709L118.281 74.6988C119.401 75.3649 120.846 74.7923 121.201 73.5415L121.871 71.1697C122.223 69.9152 123.668 69.3425 124.791 70.0124L126.571 71.0743C127.691 71.7404 129.136 71.1677 129.491 69.917L130.91 64.8934C131.154 64.0274 130.785 63.1075 130.011 62.6416L126.418 60.4963C125.646 60.0342 125.275 59.1105 125.519 58.2445L126.761 53.845C127.005 52.979 126.637 52.0591 125.862 51.5932L121.793 49.1654C120.672 48.4992 119.228 49.0719 118.872 50.3227Z",
    fill: "#3D3206"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8319 23.8681L73.5038 25.3235L78.4941 28.3051L76.8319 23.8681Z",
    fill: "#FFE133"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3097 43.2304L69.3157 40.2515L70.9816 44.6858L74.3097 43.2304Z",
    fill: "#FFE133"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0907 34.9793L79.4248 40.8716L82.7529 39.4163L81.0907 34.9793Z",
    fill: "#FFE133"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4454 27.4718L65.1173 28.9271L66.7833 33.3614L68.4454 27.4718Z",
    fill: "#FFE133"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M123.039 51.8894C121.937 51.2326 120.745 51.7498 120.379 53.0553C120.012 54.3608 120.606 55.9474 121.708 56.6042C122.81 57.261 124.002 56.7372 124.368 55.4382C124.734 54.1392 124.137 52.5489 123.039 51.8894Z",
    fill: "#FFE133"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M118.74 67.1028C117.638 66.4461 116.447 66.9633 116.08 68.2688C115.713 69.5743 116.307 71.1608 117.409 71.8176C118.511 72.4744 119.703 71.9507 120.069 70.6517C120.435 69.3527 119.838 67.7624 118.74 67.1028Z",
    fill: "#FFE133"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M127.334 63.3442C126.232 62.6874 125.041 63.2046 124.674 64.5101C124.308 65.8156 124.901 67.4022 126.003 68.059C127.105 68.7158 128.298 68.1921 128.663 66.893C129.029 65.594 128.433 64.0037 127.334 63.3442Z",
    fill: "#FFE133"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M114.444 55.648C113.342 54.9912 112.151 55.5085 111.784 56.814C111.415 58.1158 112.011 59.7061 113.114 60.3629C114.216 61.0196 115.408 60.4959 115.774 59.1969C116.139 57.8979 115.543 56.3076 114.444 55.648Z",
    fill: "#FFE133"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_48_457)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M296.479 86C284.636 86 275 76.3643 275 64.4788C275 52.5933 284.636 43 296.479 43C308.322 43 317.958 52.6357 317.958 64.4788C317.958 76.3218 308.322 85.9576 296.479 85.9576V86ZM296.479 49.8766C288.414 49.8766 281.834 56.4561 281.834 64.5212C281.834 72.5864 288.414 79.1658 296.479 79.1658C304.544 79.1658 311.123 72.5864 311.123 64.5212C311.123 56.4561 304.544 49.8766 296.479 49.8766Z",
    fill: "#E272FA"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_48_457"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 436.46,
    height: 379.02,
    fill: "white",
    transform: "translate(0 -112)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_48_457"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(217.492 7) rotate(51.5434)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_48_457"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45.78,
    height: 22.89,
    fill: "white",
    transform: "translate(387.772 23) rotate(33.9165)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_48_457"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 178.172,
    height: 335.897,
    fill: "white",
    transform: "translate(303.278 -173) rotate(53.2897)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_48_457"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 43,
    fill: "white",
    transform: "translate(275 43)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphicsRight);
export default __webpack_public_path__ + "static/media/graphics-right.8b925b18870c11df42fbc45be4cd8cde.svg";
export { ForwardRef as ReactComponent };